import * as R from 'ramda'

export const videoObjectDictionary = new Map()

export const useYoutubeCommander = () => {
  const pause = ({ url, onError }) => {
    const obj = videoObjectDictionary.get(url)
    if (R.isNil(obj)) {
      onError(`url:${url} is not in the playlist`)
      return
    }
    obj.pauseVideo()
  }

  const set = ({ url, event }) => {
    videoObjectDictionary.set(url, event.target)
  }

  const remove = ({ url }) => {
    videoObjectDictionary.delete(url)
  }
  return { pause, set, remove }
}
